import {FETCH_PRODUCTS, SEARCH, SET_PRODUCT} from '../actions/actionTypes'
import slugify from 'slugify';

const INITIAL_STATE = {products: [], product: null, searchResults: [], searchQuery: ''};

export default function (state = INITIAL_STATE, action) {


    switch (action.type) {

        case FETCH_PRODUCTS + '_FULFILLED':

            return {...state, products: updateLoadedProducts(action.payload.data)};

        case SEARCH:

            return {...state, searchResults: [], searchQuery: '' };
        case SET_PRODUCT:

            return {...state, product: action.payload};

        case SEARCH+ '_FULFILLED':


            const newResults  = [...findProducts(state.products,action.payload.hits)];

            return {...state, searchResults: newResults, searchQuery: action.payload.query };

        default:
            return state;
    }
}


function findProducts(products, foundHits){
    const result = [];
    foundHits.map ( (hit) => {

        for (let i = 0; i < products.length; i++) {
            if (products[i].id === hit.id) {
                result.push(products[i]);
                break;
            }
        }

    })
    return result

}

function updateLoadedProducts(products){
  products.map( product => {
    product.tags = product.tags ?   slugify(product.tags.toString()): ''
  })
  return products

}


